"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _draftJs = require("draft-js");

var _decorateComponentWithProps = _interopRequireDefault(require("decorate-component-with-props"));

var _BlockInlineToolbarDecorator = _interopRequireDefault(require("./BlockInlineToolbarDecorator"));

var _BlockInlineToolbarTool = _interopRequireDefault(require("./BlockInlineToolbarTool"));

var _createStore = _interopRequireDefault(require("draft-js-alignment-plugin/lib/utils/createStore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var store = (0, _createStore["default"])({
  isVisible: false
});

var updateData = function updateData(contentBlock, _ref) {
  var getEditorState = _ref.getEditorState,
      setEditorState = _ref.setEditorState;
  return function (data) {
    var entityKey = contentBlock.getEntityAt(0);

    if (entityKey) {
      var editorState = getEditorState();
      var contentState = editorState.getCurrentContent();
      contentState.mergeEntityData(entityKey, _extends({}, data));
      setEditorState(_draftJs.EditorState.forceSelection(editorState, editorState.getSelection()));

      if (data.width) {
        store.updateItem("width", data.width);
      }
    }
  };
};

var _default = function _default(config) {
  if (config === void 0) {
    config = {};
  }

  var blockToolProps = {
    store: store
  };
  return {
    initialize: function initialize(_ref2) {
      var getReadOnly = _ref2.getReadOnly,
          getEditorState = _ref2.getEditorState,
          setEditorState = _ref2.setEditorState;
      store.updateItem('getReadOnly', getReadOnly);
      store.updateItem('getEditorState', getEditorState);
      store.updateItem('setEditorState', setEditorState);
    },
    decorator: (0, _BlockInlineToolbarDecorator["default"])({
      config: config,
      store: store
    }),
    blockRendererFn: function blockRendererFn(contentBlock, _ref3) {
      var getEditorState = _ref3.getEditorState,
          setEditorState = _ref3.setEditorState;
      var entityKey = contentBlock.getEntityAt(0);
      var contentState = getEditorState().getCurrentContent();
      var blockData = entityKey ? contentState.getEntity(entityKey).data : {};
      return {
        props: {
          alignment: blockData.alignment || 'default',
          size: blockData.size || 'default',
          width: blockData.width || 100,
          updateData: updateData(contentBlock, {
            getEditorState: getEditorState,
            setEditorState: setEditorState
          })
        }
      };
    },
    BlockInlineToolbarTool: (0, _decorateComponentWithProps["default"])(_BlockInlineToolbarTool["default"], blockToolProps)
  };
};

exports["default"] = _default;
module.exports = exports.default;